// extracted by mini-css-extract-plugin
export default {"container":"XYiOH","title":"OAHSF","subtitle":"WwN+i","primaryButton":"Whs87","secondaryButton":"Jn3ZK","mobile":"_4Vuro","buttons":"Citsm"};